import React from 'react';

import { PATH } from 'src/pages/quotation';
import Layout from 'src/components/layout';
import loadable from 'src/utils/loadable';
import { IRouter } from 'src/interfaces/route';
import { SCREENS } from 'src/constants/screens';

const QuotationRoute: IRouter[] = [
  {
    element: <Layout />,
    children: [
      {
        path: PATH,
        element: loadable(() => import('src/pages/quotation')),
        title: 'quotation_page.page_title',
        screenId: SCREENS.R1005,
      },
    ],
  },
];

export default QuotationRoute;
